
  import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
  import {Storage} from 'aws-amplify';
  import iconHandler from './icon-handler.vue';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {
      ImageSelector,
      iconHandler,
    },
  })
  export default class MjImage extends Vue {
    @Prop({type: Object, default: {}}) private element!: any;

    private image: any = null;
    private text: string = '';
    private dialog: boolean = false;
    private settings: any = {
      'padding-top': '0px',
      'padding-bottom': '0px',
      'padding-left': '0px',
      'padding-right': '0px',
      'width': '',
      'src': '',
    };

    private editElement() {
      this.dialog = true;
    }

    private created() {
      this.settings = JSON.parse(JSON.stringify(this.element.settings));
    }

    @Watch('dialog')
    private updatedDialog() {
      this.$emit('updateSettings', this.settings);
    }

    private async uploadImage() {
      // TODO: check image types
      const url = this.element.id + '_' +
        Math.random().toString(36).substr(2, 3) + '.' + this.image.name.split('.').pop();
      await Storage.put(url, this.image, {level: 'public', contentType: this.image.type});
      this.settings.src = `https://d2h7nbyku08cks.cloudfront.net/${url}`;
    }
  }
